var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"img-src":"media/create-page.jpg","img-alt":"Create a Tribute Page"}},[_c('center',[_c('a',{staticClass:"btn-lg btn-primary",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.data.button))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }